// src/containers/pages/caseManagement/components/CasePanels.tsx

import React from 'react';
import { Grid } from 'components/mui';
import CasePicker from './CasePicker';
import CaseDetailsCard from './CaseDetailsCard';
import type { SelectedCustomer, CANtrackCase } from '../types';

interface CasePanelsProps {
  customer: SelectedCustomer;
  sourceCase: CANtrackCase | null;
  destinationCase: CANtrackCase | null;
  onSelectSourceCase: (caseId: number | null) => void;
  onSelectDestinationCase: (caseId: number | null) => void;
  disabled?: boolean; // true when applying
  sourceHeaderAction?: React.ReactNode; // source picker header slot (DELETE button)
  sourceResetSignal?: number; // bump clears the SOURCE picker's selection (after a delete)
}

function CasePanels({
  customer,
  sourceCase,
  destinationCase,
  onSelectSourceCase,
  onSelectDestinationCase,
  disabled,
  sourceHeaderAction,
  sourceResetSignal,
}: CasePanelsProps) {
  return (
    <Grid container spacing={2}>
      {/* Source panel */}
      <Grid item xs={12} md={6}>
        <CasePicker
          label="Source Case"
          customer={customer}
          onSelectCase={onSelectSourceCase}
          disabled={disabled}
          disabledReason={disabled ? 'Cannot change source while move is in progress' : undefined}
          currentCaseId={sourceCase?.id}
          headerAction={sourceHeaderAction}
          resetSignal={sourceResetSignal}
        />
        <CaseDetailsCard caseData={sourceCase} label="source" />
      </Grid>

      {/* Destination panel */}
      <Grid item xs={12} md={6}>
        <CasePicker
          label="Destination Case"
          customer={customer}
          onSelectCase={onSelectDestinationCase}
          disabled={disabled}
          disabledReason={disabled ? 'Cannot change destination while move is in progress' : undefined}
          currentCaseId={destinationCase?.id}
        />
        <CaseDetailsCard caseData={destinationCase} label="destination" />
      </Grid>
    </Grid>
  );
}

export default CasePanels;
